import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule, Routes } from '@angular/router';
import { FleetFinderRoutingModule } from './fleet-finder-routing.module';
import { SearchInventoryRoutingModule } from './search-inventory-routing.module';
import { HomeComponent } from '../routes/home-component/home.component';
import { NotFoundComponent } from '../routes/not-found-component/not-found.component';
import { RegisterComponent } from '../routes/register/register.component';
import { ComponentsModule } from './components.module';
import { ClientProfileComponent } from '../routes/client-profile/client-profile.component';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { ConfigService } from '../services/config-service/config.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { FaqsComponent } from '../components/faqs/faqs.component';
import { LaunchPageModule } from '../routes/launch-page/launch-page.module';
/*
import { NewBuildsLandingPageModule } from '../components/new-builds/new-builds-landing-page.module';
*/

const aboutRoute: Route = {
  path: 'faqs',
  component: FaqsComponent,
  data: {
    title: 'Frequently asked questions',
    'aria-label': 'Frequently asked questions',
  },
};

const homeRoute: Route = {
  path: '',
  component: HomeComponent,
  data: { title: 'Home', 'aria-label': 'Home' },
};

const registerRoute: Route = {
  path: 'register',
  component: RegisterComponent,
  data: { title: 'Register', 'aria-label': 'Register' },
};

const notFoundRoute: Route = {
  path: 'not-found',
  component: NotFoundComponent,
  data: { title: 'Page Not Found', 'aria-label': 'Page Not Found' },
};

const redirectRoute: Route = {
  path: '**',
  redirectTo: 'not-found',
};

const clientProfilePageRoute: Route = {
  path: 'account',
  component: ClientProfileComponent,
  data: { title: 'Client Profile', 'aria-label': 'Client Profile' },
};

const appRoutes: Routes = [
  aboutRoute,
  homeRoute,
  registerRoute,
  clientProfilePageRoute,
  notFoundRoute,
  redirectRoute,
];

@NgModule({
  declarations: [
    NotFoundComponent,
    RegisterComponent,
    HomeComponent,
    ClientProfileComponent,
  ],

  imports: [
    CommonModule,
    FleetFinderRoutingModule,
    SearchInventoryRoutingModule,
    LaunchPageModule,
    /*
    NewBuildsLandingPageModule,
*/
    ComponentsModule,
    ProgressSpinnerModule,
    TableModule,
    DialogModule,

    RouterModule.forRoot(appRoutes),
    FlexModule,
    FlexLayoutModule,
    CardModule,
    ButtonModule,
    AccordionModule,
  ],

  providers: [ConfigService],

  exports: [RouterModule],
})
export class MainRoutingModule {}
